import api from "./api.js";

export default class SmsApi {
  static async getList(data) {
    return await api.get(`api/sms-alarm`, data);
  }

  static async createSms(data) {
    return await api.post(`api/sms-alarm`, data);
  }

  static async deleteSms(data) {
    return await api.del(`api/sms-alarm`, data);
  }
}
